import React from 'react'
import useAsyncService from '../../../hooks/useAsyncService'
import { getDataspyStatus } from '../../../services/endpoints/dataSpy'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../../components/ICSErrorCard/ICSErrorCard'

import "./DataSpyEnabled.css"
import { Alert } from 'reactstrap'

export const DataSpyEnabled: React.FC = () => {
   const { serviceValue, serviceLoading, serviceError } = useAsyncService({
      serviceCall: getDataspyStatus,
      delay: 0,
      initialArgs: undefined
   })
   
   const getBody = () => {    
      if(serviceError) {
        return(
            <ICSErrorCard
              code={'error'}
              message={serviceError}
              fields={[]}
            />
        )
      } else if(serviceLoading || !serviceValue) {
        return <LoadIndicator />
      } else {
         const title = serviceValue.enabled ? 'DataSpy Enabled' : 'DataSpy Disabled'
         const color = serviceValue.enabled ? 'success' : 'warning'
         return (
                         <Alert color={color}>
                             <span className='glyphicons glyphicons-stats'></span> {title}
                         </Alert>
         )
      }
    }
   const enabled = serviceValue?.enabled

   
   return (
      <div className='dataspy-enabled'>
         {getBody()}
      </div>
   )
   
}